import { Yup } from 'cng-web-lib'

function makeValidationSchema() {

  return Yup.object({
    userProfileId: Yup.number(),
    loginId: Yup.number(),
    partyId: Yup.number(),
  })
}

export default makeValidationSchema
